import { render, staticRenderFns } from "./ProjectBuildInfoView.vue?vue&type=template&id=36d23fd0&scoped=true&"
import script from "./ProjectBuildInfoView.vue?vue&type=script&lang=js&"
export * from "./ProjectBuildInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d23fd0",
  null
  
)

export default component.exports